export const MAX_PACKAGES = 3
